import React, { useContext, useEffect, useState, useCallback } from "react";
import TopToolbar from "./Toolbar/TopToolbar";
import DeepTek from "../../../assets/DeepTek.png";
import OutlineButton from "./Tools/ToolComponents/OutlineButton";
import studyviewerContext from "../../../context/studyviewer/StudyviewerContext";
import HeatMapButton from "./Tools/ToolComponents/HeatMapButton";
import ShowOriginal from "./Tools/ToolComponents/ShowOriginal";
import { TooltipDelay, TooltipHost } from "@fluentui/react/lib/Tooltip";
import { useId } from "@fluentui/react-hooks";
import {
  ADVANCE_VIEWER_MODALITIES,
  ADVANCE_VIEWER_URL,
  BASIC_VIEWER_URL,
  COMPARE_TOOL_OBJECT,
  DEFAULT_TOOL,
  MPR_TOOL_OBJECT,
  REACT_ADVANCE_VIEWER_URL,
  REPORTDONESTATUS,
  SHOW_NOT_ORIGNAL_MODALITY_LIST,
  SHOW_OUTLINE_HEATMAP_FOR_MODALITY_LIST,
  USERTYPES,
  VDCLIMS,
  showPathologyForModalities,
} from "../../../constants/Constants";
import { DefaultButton, DirectionalHint, Icon, PrimaryButton } from "@fluentui/react";
import CustomSpinner from "../../../components/CustomSpinner";
import { useTranslation } from "react-i18next";
import {
  downloadStudyZip,
  _base64ToArrayBuffer,
} from "../../../service/StudyViewerService";
import ThumbnailContext from "../../../context/studyviewer/ThumbnailContext";
import ViewportContext from "../../../context/studyviewer/ViewportContext";
import ReportIcon from "../../../components/SVGComponents/ReportIcon";
import AddPathologyIcon from "../../../components/SVGComponents/AddPathologyIcon";
import AnnotationBox from "../../Annotations/components/AnnotationBox/AnnotationBox";
import "../styles/styles.css";
import ChevronDownIcon from "../../../components/SVGComponents/ChevronDownIcon";
import ChatIcon from "../../../components/SVGComponents/ChatIcon";
import AttachmentIcon from "../../../components/SVGComponents/AttachmentIcon";
import AttachmentBox from "./AttachmentBox/AttachmentBox";
import ClinicalNotesIcon from "../../../components/SVGComponents/ClinicalNotesIcon";
import LockStudyTopBarIcon from "../../../components/SVGComponents/LockStudyTopBarIcon";
import studyReportContext from "../../../context/studyreport/StudyReportContext";
import DownloadButton from "./Tools/ToolComponents/DownloadButton";
import Augmento from "../../../components/SVGComponents/Logo/Augmento";
import DeeptekLogo from "../../../components/SVGComponents/Logo/DeeptekLogo";
import ShareStudyLink from "../../StudyList/components/Actions/ShareStudyLink";
import ShareIcon from "../../../components/SVGComponents/ShareIcon";
import ShareStudyContext from "../../../context/sharestudy/ShareStudyContext";
import { isMobile } from "react-device-detect";
import Back from "../../../components/SVGComponents/Tools/Back";
import themeContext from "../../../context/theme/ThemeContext";
import Tool from "./Tools/ToolComponents/Tool";
import userContext from "../../../context/users/UserContext";
import MPRToolComponent from "./Tools/ToolComponents/MPRToolComponent";
import BasicViewerSwitch from "../../../components/SVGComponents/BasicViewerSwitch";
import { logAmplitudeEventWithUsernameAndRole } from "../../../helpers/Amplitude";
import AdvanceViewerSwitch from "../../../components/SVGComponents/Tools/AdvanceViewerSwitch";
import { getPaymentStatusOfStudy } from "../../../service/StudyListService";
import ConfirmModal from "../../../components/Modal/ConfirmModal";
import { toolTipStyles } from "../styles/styles";
import toolStyle from "@cornerstonejs/tools/annotation/config/ToolStyle";
import CustomToolTipHost from "../../../components/CustomToolTipHost/CustomToolTipHost";
import LockStudy from "./LockStudy/LockStudy";
import More from "../../../components/SVGComponents/Tools/More";
import VerticalMore from "../../../components/SVGComponents/Tools/VerticalMore";
import MobileViewerContext from "../../../context/studyviewer/MobileViewerContext";
import TypistAccessCode from "../../StudyList/components/Typist/TypistAccessCode";
import { CropIcon, KeyboardClassicIcon } from "@fluentui/react-icons-mdl2";
import { getViewport, resizeViewport } from "../helpers/CornerstoneViewportService";
import { opneWeasisViewer } from "../../../helpers/CommonUtility";
import MicToolComponent from "./Tools/ToolComponents/MicToolComponent";
import KeyImage from "../../../components/SVGComponents/Tools/KeyImage";
import AdvKeyImagesModal from "./AdvKeyImagesModal/AdvKeyImagesModal";
import { RectangleROITool, StackScrollTool } from "@cornerstonejs/tools";
import { eventTarget } from "@cornerstonejs/core";
import { Enums, annotation } from "@cornerstonejs/tools";
import ClippedKeyImagesModal from "./ClippedKeyImagesModal/ClippedKeyImagesModal";


const csToolsEvents = Enums.Events;


const TopBar = (props) => {
  const {
    studyData,
    messageCount,
    patientStudyData,
    studyModality,
    studyHistoryData,
    studyClinicalNotesData,
    studyParentId,
    assignmentData,
    firmViewerId,
    setSwitchingToBasic,
    parentChildReportsObj,
    getMessageCount,
    studyParentAssignmentData,
    showAttachment,
    setShowAttachment,
    showClinicalNotes,
    setShowClinicalNotes,
    advViewerUser,
    isTypistWorkflowEnabled,
    typistShowHistory,
    showChats,
    setShowShortcutModal,
    basicWeasisUser,
    setBasicWeasisUser,
    isLandscape
  } = useContext(studyviewerContext);
  const { theme, themeName } = useContext(themeContext);

    const { setShowFormatterPopupClipped } = useContext(studyReportContext);
  const [showManageAdvKeyImagesModal, setShowManageAdvKeyImagesModal] =  useState(false);
  const [showManageClippedKeyImagesModal, setShowManageClippedKeyImagesModal] =  useState(false);
  const toolBarFlex = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    margin : "0 5px"
  };

  const handleKeyImageClick = () => {
    setShowManageAdvKeyImagesModal(true);
  };

  const handleClippedKeyImageClick = () => {
   // setShowManageClippedKeyImagesModal(true);
   setShowFormatterPopupClipped(true);
  };

  const {
    disableAddPathology,
    setDisableAddPathology,
    isMPRActive,
    isChildStudyActive,
    showPriorStudyTopBar,
    viewportLoadingComplete,
  } = useContext(ViewportContext);
  const {
    showLockWarning,
    lockStudy,
    lockStudySupervisor,
    showLockButton,
    alreadyLocked,
    reportMenu,
    setShowReturnStudyModal,
    reportDoneStatusState,
    showCommunicationModal,
    setShowCommunicationModal,
    setSeriesMenu,
  } = useContext(studyReportContext);

  const {
    setShowMobileReportModal, 
    openMoreOptions, 
    setOpenMoreOptions, 
    setShowHistory, 
    showHistory,
    setSlideReportOpen,
    slideReportOpen,  
    } = useContext(MobileViewerContext);

  const { activeModality, activeStudyId } = useContext(ThumbnailContext);
  const [changeLockIcon, setChangeLockIcon] = useState(false);

  const {
    roles,
    userId,
    authenticated,
    loadByUsername,
    username,
    isActiveData,
    privilegedFirmDoctor,
    enableLlmReport
  } = useContext(userContext);

  const { showShareStudyLinkModal, setShowShareStudyLinkModal } =
    useContext(ShareStudyContext);
  
  const { cxrVersion } = useContext(studyviewerContext);

  const [paymentStatusOfStudy, setPaymentStatusOfStudy] = useState(0);
  const [paymentMessageOfStudy, setPaymentMessageOfStudy] = useState("");
  const [showPaymentAlertModal, setShowPaymentAlertModal] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showTypistModal, setShowTypistModal] = useState(false);

  const [t] = useTranslation();

  const { setActiveTool,cropAndDownloadFromAnnotation,activeViewportIndex , isCropEnable , setIsCropEnable} = useContext(ViewportContext);

  const handleStudyPaymentStatus = async () => {
    let studyId = studyParentId;
    const response = await getPaymentStatusOfStudy(studyId);
    if (response.data.result === "SUCCESS") {
      let status = response.data.data;
      if (status == VDCLIMS.PaymentStatusCodes.PAID) {
        setShowShareStudyLinkModal(true);
      } else {
        setPaymentStatusOfStudy(status);
        setPaymentMessageOfStudy(
          status == VDCLIMS.PaymentStatusCodes.DUE
            ? VDCLIMS.PAYMENT_MESSAGE_FOR_DUE
            : VDCLIMS.PAYMENT_MESSAGE_FOR_ERROR
        );
        setShowShareStudyLinkModal(false);
        setShowPaymentAlertModal(true);
        setShowConfirmModal(true);
      }
    } else {
      setPaymentStatusOfStudy(VDCLIMS.PaymentStatusCodes.ERROR);
      setPaymentMessageOfStudy(VDCLIMS.PAYMENT_MESSAGE_FOR_ERROR);
      setShowShareStudyLinkModal(false);
      setShowPaymentAlertModal(true);
      setShowConfirmModal(true);
    }
  };

  const handlePaymentAlertModal = () => {
    setShowPaymentAlertModal(false);
    setShowConfirmModal(false);
    setPaymentMessageOfStudy("");
    setPaymentStatusOfStudy(0);
  };

  const getStudyHistoryData = () => {
    if (
      activeStudyId != "" &&
      studyParentId != null &&
      studyParentId != undefined
    ) {
      if (activeStudyId == studyParentId) {
        return studyHistoryData;
      } else {
        if (
          parentChildReportsObj[activeStudyId]?.studyHistoryDocList != undefined
        ) {
          return parentChildReportsObj[activeStudyId]?.studyHistoryDocList;
        }
        return false;
      }
    }
  };

  const checkForHistoryDocsAvailable = () => {
    if (
      activeStudyId != "" &&
      studyParentId != null &&
      studyParentId != undefined
    ) {
      if (activeStudyId == studyParentId) {
        return studyHistoryData.length > 0;
      } else {
        if (
          parentChildReportsObj[activeStudyId]?.studyHistoryDocList != undefined
        ) {
          return (
            parentChildReportsObj[activeStudyId]?.studyHistoryDocList?.length >
            0
          );
        }
        return false;
      }
    }
  };

  const checkForClinicalNotesAvailable = () => {
    if (
      activeStudyId != "" &&
      studyParentId != null &&
      studyParentId != undefined
    ) {
      if (activeStudyId == studyParentId) {
        return studyClinicalNotesData.length > 0;
      } else {
        if (
          parentChildReportsObj[activeStudyId]?.history != undefined &&
          parentChildReportsObj[activeStudyId]?.history != null
        ) {
          return parentChildReportsObj[activeStudyId]?.history.length > 0;
        }
        return false;
      }
    }
  };

  const getStudyClinicalData = () => {
    if (
      activeStudyId != "" &&
      studyParentId != null &&
      studyParentId != undefined
    ) {
      if (activeStudyId == studyParentId) {
        return studyClinicalNotesData;
      } else {
        if (
          parentChildReportsObj[activeStudyId]?.history != undefined &&
          parentChildReportsObj[activeStudyId]?.history != null
        ) {
          return parentChildReportsObj[activeStudyId]?.history;
        }
        return false;
      }
    }
  };

useEffect(() =>{
  if(basicWeasisUser){
  opneWeasisViewer(studyParentId);
 }
},[basicWeasisUser]);

useEffect(() =>{
  // document.documentElement.style.setProperty( '--topbar-container-height', isLandscape ? '7.5%' : '4%' );
  document.documentElement.style.setProperty( '--topbar-container-height', isLandscape ? '7.5%' : '5.5%' );
},[isLandscape]);
  // useEffect(()=>{
  //   if(activeStudyId != "" && studyParentId != null && studyParentId != undefined){
  //       getMessageCount(activeStudyId);
  //   }
  // },[activeStudyId])

 const getstudyviewerBaseurl = () =>{
  const isAdvancedViewer = ADVANCE_VIEWER_MODALITIES.includes(studyModality) && advViewerUser;
  return isAdvancedViewer ? ADVANCE_VIEWER_URL : BASIC_VIEWER_URL;
  
 }

 useEffect(() =>{
  console.log("hey buddy ................ you are getting advViewer as : ", advViewerUser);
 }, [advViewerUser])
 
 let offset = 0;

 let toggle = false;
 function animateDashes(annotationUID) {
  //  offset = (offset + 1) % 10; // Keep offset small and cyclic
  //  toggle = !toggle;
  //  console.log("toggle value ", toggle);
   
  toolStyle.setAnnotationStyles(annotationUID, {
    lineWidth: "1px",
    textBoxLinkLineWidth: "0",
    textBoxFontSize: "0px",
    color: "#ffffff",
    colorSelected: "#ffffff",
    colorHighlighted: "#ffffff",
   
    lineDash:[5, 5] 
  });
  



  // requestAnimationFrame(() => animateDashes(annotationUID));
}




 const getSwitchViewerTitle =() =>{
  if( process.env.REACT_APP_VDC_PLATFORM == "true" ){
      if(advViewerUser){
        return "Switch to Advance Viewer";
      }else{
        return "Switch to Basic Viewer";
      }
  }
 
  return window.location.href.includes(
    "nonXrayAdvanceViewer"
  )
    ? "Switch to Basic Viewer"
    : "Switch to Advance Viewer"
}

  if (isMobile) {
    return (
      <>
        <div
          className="topbar-container w100"
          style={{
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div className="topbar-buttons">
            <div
              className="topbar-buttons cursor-pointer"
              style={{
                padding: "0px 5px",
              }}
              onClick={() => window.close()}
            >
              <Back />
            </div>
            <div
              className="topbar-buttons cursor-pointer"
              style={{
                paddingLeft: "10px",
              }}
            >
              {/* <Augmento /> */}
              <DeeptekLogo />
            </div>
          </div>
          <div
            className="topbar-buttons cursor-pointer"
            style={{
              paddingRight: "10px",
            }}
          >
            <TopToolbar
              openSeries={props.openSeries}
              seriesMenu={props.seriesMenu}
            />
            {roles[0] !== USERTYPES.FIRMDOCTOR && isMobile && (
            <div
                className="topbar-buttons cursor-pointer"
                style={{
                  position: "relative",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  paddingRight: "10px", // match others
                }}
                //onClick={() => setSlideReportOpen(prev => !prev)}
                onClick={() => {
                  setSlideReportOpen((prev) => {
                    if (!prev) setSeriesMenu(false); // Close series
                    return !prev;
                  });
                }}
                >
                <ReportIcon 
                //color={theme.palette.inactiveTool}
                color={slideReportOpen ? theme.palette.activeTool : theme.palette.inactiveTool}

                
                />
                <span
                  style={{
                    fontSize: "9px",
                    lineHeight: "100%",
                    fontWeight: "400",
                    color: "var(--mobile-color-txt)",
                    marginTop: "1px",
                  }}
                >
                  Report
                </span>
              </div>
              )}
            <div
              className="topbar-buttons cursor-pointer"
              style={{
                position: "relative",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                paddingRight: "5px",
                paddingRight: "10px",
              }}
              onClick={() => setShowCommunicationModal({ show: true, studyId: studyParentId })}
            >
              <ChatIcon 
                color={theme.palette.inactiveTool}
                active={showCommunicationModal} />
              {messageCount > 0 && (
                <span
                  className="message-count-tag"
                  style={{ top: "-2px", right: "7px" }}
                ></span>
              )}
              {isMobile && (
                <span
                  style={{
                    fontSize: "9px",
                    lineHeight: "100%",
                    fontWeight: "400",
                    //color: "#FFFFFF",
                    //color: "var(--navbar-header-popup-color-txt)",
                    color: "var(--mobile-color-txt)",
                    marginTop: "5px",
                  }}
                >
                  Chat
                </span>
              )}
            </div>
            <div
              className="topbar-buttons cursor-pointer"
              style={{
                position: "relative",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                paddingRight: "5px",
                paddingRight: "10px",
              }}
              onClick={() => {
                if (!showHistory) {
                  setOpenMoreOptions(false);
                  setSlideReportOpen(false);
                }
                setShowHistory((prev) => !prev);
              }}
            >
              <span className="topbar-toolbar-right-icons">
                <AttachmentIcon
                  color={theme.palette.inactiveTool}
                  active={showAttachment}
                />
                {checkForHistoryDocsAvailable() && !showAttachment && (
                  <span className="default-show-dot"></span>
                )}
              </span>
              {isMobile && (
                <span
                  style={{
                    fontSize: "9px",
                    lineHeight: "100%",
                    fontWeight: "400",
                    //color: "#FFFFFF",
                    //color: "var(--navbar-header-popup-color-txt)",
                    color: "var(--mobile-color-txt)",
                    marginTop: "7px",
                  }}
                >
                  History
                </span>
              )}
            </div>
            <div
              className="topbar-buttons cursor-pointer"
              style={{
                position: "relative",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                paddingRight: "5px",
              }}
              onClick={() => {
                if (!openMoreOptions) {
                  setShowHistory(false);
                  setSlideReportOpen(false);
                }
                setOpenMoreOptions((prev) => !prev);
              }}
            >
              <VerticalMore />
              {isMobile && (
                <span
                  style={{
                    fontSize: "9px",
                    lineHeight: "100%",
                    fontWeight: "400",
                    //color: "#FFFFFF",
                    //color: "var(--navbar-header-popup-color-txt)",
                    color: "var(--mobile-color-txt)",
                    marginTop: "7px",
                  }}
                >
                  More
                </span>
              )}
            </div>
          </div>
        </div>
      </>
    );
  } else {
    return (
      <>
        <div className="topbar-container w100">
          <div className="topbar-augmento-logo ">
            {/* <Augmento /> */}
            <DeeptekLogo />
          </div>
          <div className="topbar-toolbar-container">
            <div
              className={`topbar-toolbar-left-container ${
                !viewportLoadingComplete && "disable-toolbar"
              }`}
            >
              <TopToolbar
                openSeries={props.openSeries}
                seriesMenu={props.seriesMenu}
              />
            </div>
            <div className="topbar-toolbar-middle-container">
              {props.priors && <Tool tool={COMPARE_TOOL_OBJECT} />}
              {!MPR_TOOL_OBJECT.NotFor.includes(activeModality) && (
                // <Tool tool={MPR_TOOL_OBJECT} />
                <MPRToolComponent />
              )}
              {(showPathologyForModalities.includes(studyModality) ||
                showPriorStudyTopBar) &&
                (!roles[0].includes(USERTYPES.FIRMDOCTOR) || privilegedFirmDoctor) && (
                  <div style={{ display: "flex" }}>
                    {isLandscape &&<PathologyButton
                      setShowPathologyOptions={props.setShowPathologyOptions}
                      showPathologyOptions={props.showPathologyOptions}
                    />}
                  </div>
                )}

              {!SHOW_NOT_ORIGNAL_MODALITY_LIST.includes(activeModality) && isLandscape && (
                <ShowOriginal />
              )}
            </div>

            <div className="topbar-toolbar-right-container h100" style={{ display: 'flex', alignItems: 'center' }}>
              {
                <>
                  { process.env.REACT_APP_VDC_PLATFORM === "true" &&
                    process.env.REACT_APP_HYBRID_MODE == "true" && 
                    (!ADVANCE_VIEWER_MODALITIES.includes(studyModality)  || !advViewerUser ) &&(
                      <span
                        style={{
                          display: "flex",
                          margin: "0px 5px",
                          cursor: "pointer",
                          position: "relative",
                        }}
                        onClick={() => {
                          logAmplitudeEventWithUsernameAndRole(
                            "EVENT_BASIC_SWITCH_TO_BASIC_VIEWER",
                            {},
                            username
                          );
                          setSwitchingToBasic((prev) => !prev);
                          window.open(
                            getstudyviewerBaseurl() +
                              studyParentId +
                              "?firmId=" +
                              firmViewerId,
                            "_self"
                          );
                        }}
                      >
                        <div className="highlight-tool">
                          <CustomToolTipHost
                            content={getSwitchViewerTitle()}
                            id="basic-viewer"
                          >
                            <span className="topbar-toolbar-right-icons">
                              <BasicViewerSwitch />
                            </span>
                          </CustomToolTipHost>
                        </div>
                      </span>
                    )}
                  { basicWeasisUser!= null && (basicWeasisUser == true || basicWeasisUser == 'true') && (
                      <span
                        style={{
                          display: "flex",
                          margin: "0px 5px",
                          cursor: "pointer",
                          position: "relative",
                        }}
                        onClick={() => {
                          opneWeasisViewer(studyParentId)
                        }}
                      >
                        <div className="highlight-tool">
                          <CustomToolTipHost
                            content={"Open Advance Viewer"}
                            id="basic-viewer"
                          >
                            <span className="topbar-toolbar-right-icons">
                              <BasicViewerSwitch />
                            </span>
                          </CustomToolTipHost>
                        </div>
                      </span>
                    )}
                  {advViewerUser && ADVANCE_VIEWER_MODALITIES.includes(studyModality) && (
                    <span
                      style={{
                        display: "flex",
                        margin: "0px 5px",
                        cursor: "pointer",
                        position: "relative",
                      }}
                      onClick={() => {
                        window.open(
                          REACT_ADVANCE_VIEWER_URL +
                            studyParentId +
                            "?firmId=" +
                            firmViewerId,
                          "_self"
                        );
                      }}
                    >
                      <div className="highlight-tool">
                        <CustomToolTipHost
                          content={"Switch to Advance Viewera"}
                          id="basic-viewer"
                        >
                          <span className="topbar-toolbar-right-icons">
                            <AdvanceViewerSwitch
                              color={theme.palette.inactiveTool}
                            />
                          </span>
                        </CustomToolTipHost>
                      </div>
                    </span>
                  )}
                </>
              }
             
              {roles[0] == USERTYPES.RADIOLOGIST &&
                (reportDoneStatusState == REPORTDONESTATUS.SAVED ||
                  reportDoneStatusState == REPORTDONESTATUS.UNREPORTED) &&
                  (isTypistWorkflowEnabled==1 || isTypistWorkflowEnabled==2) && (
                  <div
                    className="topbar-toolbar-share-study-modal-container cursor-pointer"
                    onClick={() => setShowTypistModal(true)}
                  >
                    <CustomToolTipHost
                      delay={TooltipDelay.zero}
                      id={"Assign Typist"}
                      directionalHint={DirectionalHint.rightCenter}
                      styles={toolTipStyles}
                      content={t("heading.typist")}
                    >
                      <div className="highlight-tool">
                        <KeyboardClassicIcon
                          color={theme.palette.inactiveTool}
                        />
                      </div>
                    </CustomToolTipHost>
                  </div>
                )}
               

                 {/* here key images pop */}
                              <CustomToolTipHost
                                content={t("key-image.manage-key-image")}
                                id="key-images"
                              >
                                <span
                                  className="topbar-toolbar-key-image"
                                  style={{
                                    cursor: "pointer",
                                  }}
                                >
                                  <div style={toolBarFlex} onClick={handleKeyImageClick}>
                                    <KeyImage color={theme.palette.activeTool} />
                                  </div>
                                </span>
                              </CustomToolTipHost>
                              {showManageAdvKeyImagesModal && (
                              <AdvKeyImagesModal
                              showManageAdvKeyImagesModal={showManageAdvKeyImagesModal}
                              setShowManageAdvKeyImagesModal={
                              setShowManageAdvKeyImagesModal
                              }
                              studyId={studyParentId}
                              />
                              )}
                              
                              {/*
                              <CustomToolTipHost
                                content={t("clipped-key-images.manage-key-image")}
                                id="clipped-key-images"
                              >
                                <span 
                                 
                                  style={{
                                    cursor: "pointer",
                                  }}
                                >
                                  <div style={toolBarFlex} onClick={handleClippedKeyImageClick}>
                                   <span style={{marginLeft:"10px"}} className="clipping-image-tool" > </span>
                                  </div>
                                </span>
                              </CustomToolTipHost> */}
                              {showManageClippedKeyImagesModal && (
                              <ClippedKeyImagesModal
                              showManageClippedKeyImagesModal={showManageClippedKeyImagesModal}
                              setShowManageClippedKeyImagesModal={
                              setShowManageClippedKeyImagesModal
                              }
                              studyId={studyParentId}
                              />
                              )}

              <div className="highlight-tool cursor-pointer">
                <MicToolComponent />
              </div>
                <LockStudy
                  changeLockIcon={changeLockIcon}
                  setChangeLockIcon={setChangeLockIcon}
                />
              {
                 <div className="highlight-tool cursor-pointer" >
                 <CustomToolTipHost
                   content={"Shortcut Information"}
                   id="Shortcut"
                 >
                   <span className="topbar-toolbar-right-icons" onClick={()=>setShowShortcutModal(true)}>
                   <Icon 
                      iconName="info"  
                      style={{fontSize:"18px",
                          marginTop: "2px",
                          
                          color:theme.palette.inactiveTool,
                      }}></Icon>
                    </span>
                </CustomToolTipHost>
               </div>
              }
              { ((roles[0] == USERTYPES.TYPIST && typistShowHistory) || roles[0] != USERTYPES.TYPIST) && <><span
                className="topbar-toolbar-history"
                style={{
                  cursor: checkForHistoryDocsAvailable()
                    ? "pointer"
                    : "not-allowed",
                }}
                onClick={() => {
                  if (checkForHistoryDocsAvailable()) setShowAttachment(true);
                }}
              >
                <span
                  style={{
                    display: "flex",
                    cursor: checkForHistoryDocsAvailable()
                      ? "pointer"
                      : "not-allowed",
                    position: "relative",
                  }}
                  onClick={() => {
                    if (checkForHistoryDocsAvailable()) setShowAttachment(true);
                  }}
                >
                  <div className="highlight-tool">
                    <CustomToolTipHost
                      content={
                        checkForHistoryDocsAvailable()
                          ? t("heading.attachment")
                          : t("search-message.no-attachment")
                      }
                      id="Attachment"
                    >
                      <span className="topbar-toolbar-right-icons">
                        <AttachmentIcon
                          color={theme.palette.inactiveTool}
                          active={showAttachment}
                        />
                        {checkForHistoryDocsAvailable() && !showAttachment && (
                          <span className="default-show-dot"></span>
                        )}
                      </span>
                    </CustomToolTipHost>
                  </div>
                  <div>
                    <AttachmentBox
                      boxName="history"
                      show={showAttachment}
                      onClickOutside={() => {
                        setShowAttachment(false);
                      }}
                      setShowPathologyOptions={props.setShowPathologyOptions}
                      setShowInfo1={showAttachment}
                      studyHistoryData={getStudyHistoryData()}
                    />
                  </div>
                </span>
              </span>

              <span
                className="topbar-toolbar-history"
                style={{
                  cursor: checkForClinicalNotesAvailable()
                    ? "pointer"
                    : "not-allowed",
                }}
                onClick={() => {
                  checkForClinicalNotesAvailable() &&
                    setShowClinicalNotes(true);
                }}
              >
                <div className="highlight-tool">
                  <CustomToolTipHost
                    content={
                      checkForClinicalNotesAvailable()
                        ? t("heading.clinical-notes")
                        : t("search-message.no-clinical-notes")
                    }
                    id="ClinicalNotes"
                  >
                    <span className="topbar-toolbar-right-icons">
                      <ClinicalNotesIcon
                        color={theme.palette.inactiveTool}
                        active={showClinicalNotes}
                      />
                      {checkForClinicalNotesAvailable() &&
                        !showClinicalNotes && (
                          <span className="default-show-dot"></span>
                        )}
                    </span>
                  </CustomToolTipHost>
                </div>
                <div>
                  <AttachmentBox
                    boxName="notes"
                    show={showClinicalNotes}
                    onClickOutside={() => {
                      setShowClinicalNotes(false);
                    }}
                    setShowPathologyOptions={props.setShowPathologyOptions}
                    setShowInfo1={showClinicalNotes}
                    studyClinicalNotesData={getStudyClinicalData()}
                  />
                </div>
              </span>
              </>}

              <div className="separator-topbar-items"></div>
              <div className="topbar-buttons">
                {((roles[0] == USERTYPES.TYPIST && showChats) || roles[0] != USERTYPES.TYPIST) && <div
                  className="topbar-toolbar-communication cursor-pointer"
                  onClick={() => setShowCommunicationModal(true)}
                >
                  <div className="highlight-tool">
                    <CustomToolTipHost content={t("label.chat")} id="Chat">
                      <span className="topbar-toolbar-right-icons">
                        <ChatIcon
                          //color={true}
                          color={theme.palette.inactiveTool}
                          active={showCommunicationModal}
                        />
                        {messageCount > 0 && !isChildStudyActive && (
                          <span className="message-count-tag"></span>
                        )}
                      </span>
                    </CustomToolTipHost>
                  </div>
                </div>}

                {
                  <div className="topbar-toolbar-communication-modal-container cursor-pointer">
                    <div className="highlight-tool">
                      <DownloadButton />
                    </div>
                  </div>
                }

                {showTypistModal && (
                  <TypistAccessCode
                    setShowTypistModal={setShowTypistModal}
                    studyId={studyParentId}
                  isTypistWorkflowEnabled={isTypistWorkflowEnabled}/>
                )}
                {showShareStudyLinkModal && (
                  <ShareStudyLink
                    studyId={studyParentId}
                    firmId={assignmentData.firmId}
                    clientId={assignmentData.clientId}
                  />
                )}
                {showPaymentAlertModal && (
                  <ConfirmModal
                    handleConfirm={handlePaymentAlertModal}
                    handleNotConfirm={handlePaymentAlertModal}
                    setShowConfirmModal={setShowConfirmModal}
                    showConfirmModal={showConfirmModal}
                    message={paymentMessageOfStudy}
                    title={t("confirm-message.alert")}
                    confirmButtonText={t("confirm-message.ok")}
                    cancelButtonText={t("confirm-message.cancel")}
                  />
                )}

                {isActiveData && (
                  <div
                    className="topbar-toolbar-share-study-modal-container cursor-pointer"
                    onClick={() => handleStudyPaymentStatus()}
                  >
                    <CustomToolTipHost
                      delay={TooltipDelay.zero}
                      id={"Share Study"}
                      directionalHint={DirectionalHint.rightCenter}
                      styles={toolTipStyles}
                      content={isMobile ? "" : t("share-study.title")}
                    >
                      <div className="highlight-tool">
                        <ShareIcon color={theme.palette.inactiveTool} />
                      </div>
                    </CustomToolTipHost>
                  </div>
                )}
              </div>
              {roles.length > 0 && (!roles[0].includes(USERTYPES.FIRMDOCTOR) || privilegedFirmDoctor) && isLandscape && (
                <CustomToolTipHost content="Report" id="View Report">
                  <button
                    onClick={props.openReport}
                    className="view-report-primay-button"
                    style={{
                      background: reportMenu
                        ? "rgb(0, 120, 212)"
                        : "transparent",
                      border: reportMenu
                        ? "1px solid transparent"
                        : themeName != "light"
                        ? "1px solid #C3C4CD"
                        : "1px solid rgb(41 41 41)",
                    }}
                  >
                    <span style={{ display: "flex" }}>
                      <ReportIcon active={reportMenu} color={theme.palette.inactiveTool} />
                    </span>
                    <span className="view-report-button-text" style={{color:reportMenu || themeName !== "light"?"#FFF":"#000"}}>
                      {t("report-version.report")}
                    </span>
                  </button>
                </CustomToolTipHost>
              )}
            </div>
          </div>
        </div>
      </>
    );
  }
};

export default TopBar;

export const PathologyButton = (props) => {
  const { roles, authenticated, loadByUsername, username, enableLlmReport} =
    useContext(userContext);
  const [showInfo1, setShowInfo1] = useState(false);
  const { themeName,getAlterColor,theme ,getThemeColor} = useContext(themeContext);
  const {
    disableAddPathology,
    setDisableAddPathology,
    originalImageActiveState,
    activeViewportIndex,
  } = useContext(ViewportContext);
  const {cxrVersion} = useContext(studyviewerContext)

  const { isChildStudyActive } = useContext(ViewportContext);
  const [delayHandler, setDelayHandler] = useState(null);
  const { isClientReportExist, isWordFilePath, allReportTemplatesLoading } =
    useContext(studyReportContext);
  const [t] = useTranslation();

  const onHideContextualMenu = useCallback(() => setShowInfo1(false), []);

  const hideContextMenu = () => {
    clearTimeout(delayHandler);
    setDelayHandler(
      setTimeout(() => {
        setShowInfo1(false);
      }, 300)
    );
  };

  const onShowContextualMenu = (ev) => {
    ev.preventDefault(); // don't navigate

    clearTimeout(delayHandler);
    setDelayHandler(
      setTimeout(() => {
        setShowInfo1(true);
      }, 300)
    );
  };

  useEffect(() => {
    clearTimeout(hideContextMenu);
  }, [showInfo1]);

  return (
    <div
      className="pathology-button-topbar"
      onClick={() => {
        if (!isChildStudyActive)
          props.setShowPathologyOptions(!props.showPathologyOptions);
          let resizeInterval = setInterval(async () => {
            await resizeViewport();
          }, 200)
          setTimeout(() => {
            clearInterval(resizeInterval)
          }, 600)
      }}
      style={{
        background:
          props.showPathologyOptions && !isChildStudyActive && !isWordFilePath
            ? theme.palette.viewerButtonColor
            : isChildStudyActive || isWordFilePath
            ? "rgba(215, 214, 214, 0.57)"
            : "none",
        border: props.showPathologyOptions
          ? "1px solid transparent"
          : themeName != "light"
          ? "1px solid #C3C4CD"
          : "1px solid rgb(41 41 41)",
        cursor:
          !isChildStudyActive && !isWordFilePath ? "pointer" : "not-allowed",
      }}
    >
      {!cxrVersion && <div
        className="annotation-add-icon-topbar"
        onClick={(e) => {
          e.stopPropagation();
          if (
            !disableAddPathology &&
            roles[0] == USERTYPES.RADIOLOGIST &&
            !isChildStudyActive &&
            !isWordFilePath
          ) {
            setShowInfo1((prev) => !prev);
          }
        }}
        onMouseEnter={(ev) => {
          if (
            !disableAddPathology &&
            roles[0] == USERTYPES.RADIOLOGIST &&
            !isChildStudyActive &&
            !isWordFilePath
          ) {
            onShowContextualMenu(ev);
            // setShowInfo1(true);
          }
        }}
        onMouseLeave={(e) => {
          e.stopPropagation();
          hideContextMenu();
        }}
        style={{
          display:
            !disableAddPathology &&
            roles[0] == USERTYPES.RADIOLOGIST && !enableLlmReport &&
            !allReportTemplatesLoading &&
            isClientReportExist != null &&
            !isClientReportExist
              ? "flex"
              : "none",
        }}
      >
        <AddPathologyIcon active={showInfo1} open={props.showPathologyOptions} isChildStudyActive={isChildStudyActive} />
        <div
          onMouseEnter={(ev) => {
            if (
              !disableAddPathology &&
              roles[0] == USERTYPES.RADIOLOGIST && !enableLlmReport &&
              !allReportTemplatesLoading &&
              isClientReportExist != null &&
              !isClientReportExist
            ) {
              onShowContextualMenu(ev);
            }
          }}
          onMouseLeave={(e) => {
            e.stopPropagation();
            hideContextMenu();
          }}
        >
          <AnnotationBox
            show={showInfo1}
            onClickOutside={() => {
              setShowInfo1(false);
            }}
            setShowPathologyOptions={props.setShowPathologyOptions}
            setShowInfo1={setShowInfo1}
          />
        </div>
      </div>}
      {!cxrVersion&& !disableAddPathology &&
        roles[0] == USERTYPES.RADIOLOGIST && !enableLlmReport &&
        !allReportTemplatesLoading &&
        isClientReportExist != null &&
        !isClientReportExist && 
        <span className="border-topbar"
          style={{
            background: 
             props.showPathologyOptions && !isChildStudyActive && !isWordFilePath
             ? getThemeColor("border-topbar-active")
             : getThemeColor("border-topbar-inactive"),
          }}
        ></span>}
      <span style={{ color: props.showPathologyOptions && !isChildStudyActive && !isWordFilePath ? getAlterColor("#FFF","#FFF") : getAlterColor("#FFF","#000") }} className="pathology-text-topbar">
        {t("studyviewer.pathologies")}
      </span>
     
      {!cxrVersion && !disableAddPathology &&
        roles[0] == USERTYPES.RADIOLOGIST && !enableLlmReport &&
        !allReportTemplatesLoading &&
        isClientReportExist != null &&
        !isClientReportExist && (
          // <span className="down-icon-topbar">
          //   <ChevronDownIcon />
          // </span>
        //   <span 
        //   className={`down-icon-topbar ${props.showPathologyOptions && !isChildStudyActive && !isWordFilePath 
        //     ? "icon-active" 
        //     : "icon-inactive"}`}
        // >
        <span 
          className="down-icon-topbar"
        >
          <ChevronDownIcon 
          color={props.showPathologyOptions && !isChildStudyActive && !isWordFilePath 
            ? getAlterColor("#FFF","#FFF") 
            : getAlterColor("#FFF","#000")
          }/>
          </span>
        )}

    </div>
  );
};
